import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgRoulette = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18.495 17.483a8.48 8.48 0 0 1-5.745 2.984v-3.042a5.46 5.46 0 0 0 3.257-1.692zm.864-1.226A8.46 8.46 0 0 0 20.5 12a8.46 8.46 0 0 0-1.15-4.272l-2.485 1.755c.39.754.611 1.61.611 2.517 0 .903-.219 1.755-.606 2.507zm-.875-9.754a8.48 8.48 0 0 0-5.734-2.97v3.042a5.46 5.46 0 0 1 3.249 1.684zm-7.234-2.97a8.48 8.48 0 0 0-5.745 2.984l2.489 1.75a5.46 5.46 0 0 1 3.256-1.692zM3.5 12a8.46 8.46 0 0 1 1.141-4.257l2.49 1.75A5.45 5.45 0 0 0 6.523 12c0 .907.22 1.763.61 2.517L4.65 16.272A8.46 8.46 0 0 1 3.5 12m7.75 8.467a8.48 8.48 0 0 1-5.734-2.97l2.485-1.756a5.46 5.46 0 0 0 3.249 1.684zM12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M8.024 12a3.976 3.976 0 1 1 7.952 0 3.976 3.976 0 0 1-7.952 0m-2.1 0a.675.675 0 1 1-1.351 0 .675.675 0 0 1 1.35 0M12 8.55a.75.75 0 0 1 .75.75v.737c.557.213 1 .656 1.213 1.213h.738a.75.75 0 0 1 0 1.5h-.739c-.212.557-.655 1-1.212 1.213v.738a.75.75 0 0 1-1.5 0v-.739c-.557-.212-1-.655-1.213-1.212H9.3a.75.75 0 0 1 0-1.5h.739c.212-.557.655-1 1.212-1.213V9.3a.75.75 0 0 1 .75-.75M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgRoulette;
